import { render, staticRenderFns } from "./body-element.vue?vue&type=template&id=0fa9c6d6&scoped=true&"
import script from "./body-element.vue?vue&type=script&lang=ts&"
export * from "./body-element.vue?vue&type=script&lang=ts&"
import style0 from "./body-element.vue?vue&type=style&index=0&id=0fa9c6d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa9c6d6",
  null
  
)

export default component.exports